<template>
    <div class="media-uploader">
        <div v-if="hasErrors" class="media-uploader__errors">
            <p class="media-uploader__errors__title">Some file(s) could not be uploaded.</p>
            <icon @click.native="clearErrors" class="media-uploader__errors__close" type="cross" color="dark" />
            <span v-for="error in errors" :key="error" class="media-uploader__error">{{ error }}</span>
        </div>

        <div v-if="isUploadingFiles" class="uploads">
            <article class="upload upload--progress">
                <template v-if="fileToUpload">
                    <p class="upload__title">{{ fileToUpload.name }}</p>
                    <span class="upload__meta">{{ fileToUpload.size | formattedSize }}</span>
                </template>
                <div class="progress upload__progress">
                    <!--TODO: Fix progress bar is it does not update the property-->
                    <div class="progress__bar">
                        <span :style="{width: percentCompleted + '%'}" />
                    </div>
                    <p class="progress__status">{{ percentCompleted }}%</p>
                </div>
            </article>
        </div>

        <div @dragenter="isDraggingFiles = true"
             @dragover.prevent="isDraggingFiles = true"
             @dragleave="isDraggingFiles = false"
             @dragend="isDraggingFiles = false"
             @drop.prevent="onFilesDropped"
             ref="dropzone"
             class="dropzone"
             :class="{ 'dropzone--active': isDraggingFiles }"
             v-show="isDraggingFiles">

            <span class="dropzone__title">Drop to upload to this job</span>

            <input @click.stop
                   ref="input"
                   class="lc-file-input"
                   type="file"
                   v-show="false"
                   multiple="multiple"
                   @change="onFilesSelected"
            >
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    data () {
        return {
            filesToUpload: [],
            errors: [],
            isUploadingFiles: false,
            currentUploadIndex: 0,
            percentCompleted: 0,
            isDraggingFiles: false
        }
    },

    methods: {
        openFileBrowser () {
            this.$refs.input.click()
        },

        onFilesDropped (evt) {
            this.isDraggingFiles = false

            if (!evt.dataTransfer) {
                return
            }

            let files = evt.dataTransfer.files

            for (var i = 0; i < files.length; i++) {
                this.filesToUpload.push(files[i])
            }

            this.startUpload()
        },

        onFilesSelected (evt) {
            if (!evt.target.files) {
                return
            }

            for (let file of evt.target.files) {
                this.filesToUpload.push(file)
            }

            this.startUpload()
        },

        startUpload () {
            if (this.isUploadingFiles) {
                return
            }

            this.isUploadingFiles = true
            this.$emit('uploading')
            this.uploadNextFile()
        },

        uploadNextFile () {
            if (this.hasAnotherFileToUpload) {
                this.uploadSingleFile(this.fileToUpload).then(() => {
                    this.uploadNextFile()
                })

                return this.currentUploadIndex++
            }

            this.finishedUploading()
        },

        uploadSingleFile (file) {
            let form = new Form({
                file: file,
                onUploadProgress: (progressEvent) => {
                    this.percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total)
                }
            })

            return form.post(`/api/job/${this.job.id}/asset`).then((file) => {
                this.$emit('uploaded', file)
            }).catch((errors) => {
                this.errors = errors
            })
        },

        finishedUploading () {
            this.currentUploadIndex = 0
            this.percentCompleted = 0
            this.filesToUpload = []
            this.isUploadingFiles = false
            this.$emit('finished')
            if (this.$refs.input) {
                this.$refs.input.value = ''
            }
        },

        clearErrors () {
            this.errors = []
        }
    },

    computed: {
        ...mapState('job', ['job']),

        hasErrors () {
            return this.errors.length > 0
        },

        hasAnotherFileToUpload () {
            return this.currentUploadIndex < this.filesToUpload.length
        },

        fileToUpload () {
            return this.filesToUpload[this.currentUploadIndex]
        }
    }
}
</script>
